import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Hero } from '@/features/home/Hero';
import { Pillars } from '@/features/home/Pillars';
import { Services } from '@/features/home/Services';
import { Process } from '@/features/home/Process';
import { PhotoBand } from '@/features/home/PhotoBand';
import { Projects } from '@/features/home/Projects';
import { Trust } from '@/features/home/Trust';
import { Contact } from '@/features/home/Contact';

export function HomePage() {
  const { t, i18n } = useTranslation();

  // Keep the document title in sync with the active language.
  useEffect(() => {
    document.title = `PV Yourself — ${t('hero.eyebrow')} | Plan & Volt`;
  }, [t, i18n.resolvedLanguage]);

  return (
    <>
      <Hero />
      {/* Proof of real work sits directly under the hero. */}
      <Projects />
      <Pillars />
      <Services />
      <Process />
      <PhotoBand />
      <Trust />
      <Contact />
    </>
  );
}

export default HomePage;
